import { Email } from '@app/models/account/email.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<Email> {
    title = 'account.status';
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(email: Email): BadgeDisplay | undefined {
        if (email.isPrimary) {
            return { type: 'success', label: 'account.primary' };
        }
        if (email.isVerified) {
            return { type: 'informative', label: 'account.verified' };
        }
        return { type: 'danger', label: 'account.unverified' };
    }
}
